import http from "../services/http";

export const apiGetDashboard = async (filter = 1) => {
  try {
    const response = await http.get("/api/doctor/dashboard", {
      params: { filter },
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const apiGetNotifications = async (params = {}) => {
  try {
    const response = await http.get("/api/notification/list", {
      params: {
        page: params.page || 1,
        per_page: params.per_page || 10,
        filter_by: params.filter_by || 1,
        status: params.status
      },
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
